$(function () {

    // polyfill for JS closest
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            var el = this;

            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    // toggle panel used by search and primary menu
    var TogglePanel = function (menuBtnElement, navElement, closeBtnElement) {

        var hideMenu = function() {
			$('html').on('click', function(e) {
                if ($(navElement).is(':visible')) {
                    var isNav = e.target.closest(navElement) || e.target.id === navElement ? true : false;

                    if (!isNav) {
                        $(navElement).is(':visible') ? $(navElement).fadeOut() : $(navElement).fadeIn();
                    }
                }
            });
        };

        var click = function() {
            $(navElement).is(':visible') ? $(navElement).fadeOut() : $(navElement).fadeIn();
        };

        var init = function () {
            var self = this;

			$(menuBtnElement).on('click', function (e) {
                e.stopPropagation();
                click();
            });

			$(closeBtnElement).on('click', function (e) {
                e.stopPropagation();
                click();
            });
            
            hideMenu();
        };
        
        init();
        
    };
	
    /* iframe fix height in tiles */
	var IframeCheck = {
	    containers: [
            ".videoHolder",
            ".tileIframe"
	    ],
	    init: function () {
	        for (var i = 0; i < this.containers.length; i++) {
	            if ($(this.containers[i]).length > 0) {
	                this.setHeight(this.containers[i]);
	            }
	        }
	    },
	    setHeight: function (el) {
	        if ($(el).height() != null) {
	            $(".wrapper").children().find($(el)).each(function (i) {
	                var str = $(this).parentsUntil('tile').attr('class');
	                if (str.indexOf("tile2x1") >= 0) {
	                    $(this).children('iframe').height('256px');
	                } else if (str.indexOf("tile2x2") >= 0) {
	                    $(this).children('iframe').height(iframeSize);
	                } else if (str.indexOf("tile3x2") >= 0) {
	                    $(this).children('iframe').height(iframeSize);
	                } else if (str.indexOf("tile4x2") >= 0) {
	                    $(this).children('iframe').height(iframeSize);
	                } else {

	                }
	            });
	        }
	    }
	}
	IframeCheck.init();
    /* ssm - simple state manager */
	var iframeSize = '512px';
	var windowWidth = 0;
	ssm.addStates([
    {
        id: 'mobile',
        maxWidth: 480,
        onEnter: function () {
            iframeSize = '256px';
            windowWidth = 600;
            IframeCheck.init();
        }
    },
    {
        id: 'tablet',
        minWidth: 481,
        maxWidth: 1023,
        onEnter: function () {
            iframeSize = '512px';
            windowWidth = 1200;
            IframeCheck.init();
        }
    },
    {
        id: 'desktop',
        minWidth: 1024,
        onEnter: function () {
            iframeSize = '512px';
            windowWidth = 600;
            IframeCheck.init();
        }
    }
	]).ready();
    /* video tile */
	$("a.playButton").on('click', function (e) {
		e.preventDefault();
	    $(".wrapper").children().find('.tileIframe').each(function () {
	        $(this).removeClass("hidden");
	        $(this).nextAll().addClass('hidden');
	    });
	});

	/* contact us - tab sort */
	var TabSort = {
		container: '.tabContainer',
		ul: 'ul.tabs',
		expandBtnOpen: $('.plusIcon'),
		expandBtnClose: $('.minusIcon'),
        expand: $('.expand'),
		refs: [],
		init: function() {
	        //Selected tab needs to be selected when going to a link and then back again in browser.
		    var hashValue = document.location.hash.replace("#", "");
		    if (hashValue === '' || isNaN(parseInt(hashValue))) {
		        hashValue = '';
		    }
	        var selectedTabClass = "pageid_" + hashValue;

	        if (selectedTabClass != 'pageid_' && hashValue != '' && hashValue != 'undefined') {
	            var tab = $('.' + selectedTabClass);
	            TabSort.change(tab);
	        }

	        //get id's
	        $(this.ul).children('li').each(function(el) {
	            TabSort.refs.push($(this).data("panelref"));
	        });
			$(this.ul + ' li a').on('click', function(e) {
	            e.preventDefault();
	            TabSort.change($(this).parent('li'));
	            document.location.hash = $(this).parent('li').data("pageid");
	            return false;
	        });
	        $(this.ul).children('li').each(function(e) {
	            if ($(this).hasClass('selected')) {
	                TabSort.change($(this));
	            }
	        });

			this.expand.on('click', function(e) {
	            var prodTable = $(this).parent().next('td').find('.productInfo');
	            if ($(this).hasClass('plusIcon')) {
	                $(this).removeClass('plusIcon').addClass('minusIcon');
	            } else {
	                $(this).removeClass('minusIcon').addClass('plusIcon');
	            }

	            if (prodTable.hasClass('hidden')) {
	                prodTable.removeClass('hidden');
	            } else {
	                prodTable.addClass('hidden');
	            }

        	});

		},
		change: function(id) {
			$(this.ul).children('li').each(function() {
				if ($(this).hasClass('selected')) {
					$(this).removeClass('selected');
				}
			});
			var panelID = $(id).data('panelref');
			$(id).addClass('selected');
			for (var i = 0; i < this.refs.length; i++) {
				if (this.refs[i] == panelID) {
					//set visible
					$(this.container + ' div#'+panelID).show();
				} else {
					//set hidden
					$(this.container + ' div#'+this.refs[i]).hide();
				}
			}
		}
	}
	TabSort.init();

    /* product image slider */
	var ImageSlider = {
		current: 0,
		nrOfImg: 0,
		path: '',
		images: [],
		container: '.imgContainer',
		status: '.status',
		animate: false,
		animationSpeed: 500,
		changeBackgroundCol: false,
		thumbContainer: '.thumbContainer',
		init: function(arr) {
			this.images = arr;
			this.nrOfImg = this.images.length;
			this.changeImage();
			//Check for mobile
			this.testPad();
			$(this.thumbContainer + ' a').on('click', function(e) {
				e.preventDefault();
				ImageSlider.current = $(this).data('id');
				ImageSlider.changeImage();
			});
		},
		buttons: [
            'loadPrev',
            'loadNext',
            '.imgNav a.changeAnimate'
	    ],
	    testPad: function() {
	    	$(this.container).on('swipeleft', function(e) {
	    		ImageSlider.change('<');
	    		$(ImageSlider.status).html("swipe left");
	    	});
	    	$(this.container).on('swiperight', function(e) {
	    		ImageSlider.change('>');
	    		$(ImageSlider.status).html("swipe right");
	    	});
	    },
		change: function(dir) {
			switch(dir) {
				case '<':
					this.current = this.current-1;
					break;
				case '>':
					this.current = this.current+1;
					break;
			}
			if (this.animate) {
				$(this.container).animate({
					opacity: 0/*,
					'background-size': 'cover'*/
				},this.animationSpeed, function() {
					ImageSlider.changeImage();	
				});
			} else {
				this.changeImage();
			}
			
		},
		changeImage: function() {
			if (this.current >= this.nrOfImg) {
				this.current = 0;
			}
			if (this.current < 0) {
				this.current = this.nrOfImg-1;
			}
			$(this.container).css({
				'background-image': 'url('+this.path+this.images[this.current]+')'
			});
			if (this.animate) {
				$(this.container).animate({
					opacity: 1
				}, this.animationSpeed);
			}
			 if (this.nrOfImg > 1) {
	           
	        } else {
	            
	        }
	        if (this.changeBackgroundCol) {
	        	this.changeBgColor();
	        }
		},
		changeBgColor: function() {
			//check imgformat
			if (/jpg/i.test(images[this.current])) {
				$("#focusArea.products").css('background-color', '#fff');
			} else {
				$("#focusArea.products").css('background-color', 'rgb(240, 241, 242)');
			}
		},
		createThumb: function(i) {
		}
	}
	if (typeof imgArr == "undefined") {
        //not product listing
	} else {
	    ImageSlider.init(imgArr);
	}

	//Aftermarked
	if (typeof distributors_data == 'undefined') {

	} else {
		var dist = new Distributors();
		dist.init(distributors_data);
	}
	
	/* animated content block 2x1 */
	var BlockContentSlider = function() {
		var scope = this;
		var slider = '.slider > .tileContent > div.contentWrapper .carouselItems';
		var antChildren;
		var currentSlider = -1;
		var sliderSpeedInt = 2500;
		var aniSpeed = 500;
		var looper;
		var firstRun = true;
		this.init = function() {
			$(slider).children().each(function(i) {
				$(this).css('width', windowWidth);
				antChildren = i+1;
			});
			scope.startSlider();
		};
		this.startSlider = function() {
			if (firstRun) {
				aniSpeed = 0;
				firstRun = false;
				scope.revealSlide($(slider).children().eq(0));
				currentSlider = 0;
			}
			looper = setInterval(function() {
				aniSpeed = 500;
				if (currentSlider > -1) scope.removeSlide($(slider).children().eq(currentSlider))
				if (currentSlider < antChildren-1) {
					currentSlider++;
				} else {
					currentSlider = 0;
				}
				scope.revealSlide($(slider).children().eq(currentSlider));
			}, sliderSpeedInt);
		};
		this.removeSlide = function(el) {
			el.animate({
				left: -windowWidth+'px'
			}, aniSpeed+100, 'easeInSine');
		};
		this.revealSlide = function(el) {
			el.css('left', windowWidth+'px')
			el.animate({
				left: 0
			}, aniSpeed, 'easeOutSine');

		};
	}
	//check if tile .slider is present
	if ($('body.startPage')) {
		var sliderCount = -1;
		$('.tileRow').find('.tile2x1.tile.dark').each(function(i) {;
			sliderCount++;
		});
		if (sliderCount >= 0) {
			var slider = new BlockContentSlider();
			slider.init();	
		}
	};

    var searchPanel = new TogglePanel('#open-search', '#header-search', '#close-search');
	var menuPanel = new TogglePanel('#open-menu', '#mainNav', '#close-menu');

	//Product detail tables
	const Panels = (function () {
		$('.detail-tabs button').each(function () {
			$(this).on('click', function () {
				Reset();
				$(this).addClass('active');
				ShowPanel($(this));
			});
		});
	});

	const Reset = function () {
		$('.detail-tabs button').each(function () {
			$(this).removeClass('active');
		});

		$('.js-panel').each(function () {
			$(this).removeClass('active');
		});
	};

	const ShowPanel = function (tab) {
		var id = tab.attr('id');
		if (id === 'downloads-tab') {
			document.querySelector('#downloads').classList.add('active');
		} else if (id === 'imperial-tab') {
			document.querySelector('#imperial').classList.add('active');
		} else if (id === 'metric-tab') {
			document.querySelector('#metric').classList.add('active');
		} else if (id === 'mobile-details-tab') {
			document.querySelector('#mobile-details').classList.add('active');
		} else if (id === 'mobile-downloads-tab') {
			document.querySelector('#mobile-downloads').classList.add('active');
		}
	};

	const MobileAccordion = (function () {
		var acc = document.querySelectorAll('.contentMobile .heading');
		if (acc) {
			for (var i = 0; i < acc.length; i++) {
				acc[i].addEventListener('click', function () {
					var content = this.nextElementSibling;

					if (content.style.maxHeight) {
						content.style.maxHeight = null;
						this.classList.remove('open');
					} else {
						for (var i = 0; i < acc.length; i++) {
							acc[i].nextElementSibling.style.maxHeight = null;
							acc[i].classList.remove('open');
						}
						this.classList.add('open');
						content.style.maxHeight = content.scrollHeight + 'px';
					}
				});
			}
		}
	});
	MobileAccordion();
	Panels();
});
$(document).on('click', function (e) {
    if (window.location.hash) {
        // Menu open
        var hash = window.location.hash.substring(1);
        if (hash == 'mainNav') window.location.hash = "";
    }
});